import axiosInstance from "../axiosInstance";
import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const EditorCreateMutation = async (body) => {
  try {
    const res = await ApiRequest.post(endpoints.Editor.create, body);

    return res;
  } catch (error) {
    return error;
  }
};

// export const EditorVIDEOMutation = async (data) => {
//   console.warn(
//     "🚀 ~ file: editor.api.ts:16 ~ EditorVIDEOMutation ~ dataasdasd:",
//     data
//   );

//   return new Promise((resolve, reject) => {
//     ApiRequest.get(
//       `${endpoints.videos.videos}?editor_id=${data?.editor_id}&page=${data?.page}`
//     )
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

export const EditorVIDEOMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.videos.videos}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const EditorUserDeatilsutation = async (data) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.auth.userdeatils}?user_id=${data}`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// export const totaleditorList = () => {
//   return new Promise((resolve, reject) => {
//     ApiRequest.get(`${endpoints.Editor.editorList}`)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };
export const totaleditorList = (data, page) => {
  console.warn(
    "🚀 ~ file: editor.api.js:93 ~ totaleditorList ~ dataasddsa:",
    data
  );

  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.Editor.editorList}?status=${page?.status}&search=${page?.search}&published_at_from=${page?.startDate}&published_at_to=${page?.endDate} &page=${data}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const searcheditorList = (data) => {
  console.warn(data, "api data");
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.Editor.editorList}?search=${data}`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const activeeditorList = (data) => {
  console.warn(data, "apidata");
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.Editor.editorList}?status=${data}`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const filtereditorList = (date) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.Editor.editorList}?published_at_from=${date.startDate}&published_at_to=${date.endDate}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
